module.exports = __webpack_public_path__ + "static/media/Q2-10.a07e3aa5.jpg";